import React from 'react';
import './Header.css';
const header=()=>{
    return <span className="header"
    onClick={()=>window.scroll(0,0)}>Teenflix</span>
 
}


export default header;